import styled from 'styled-components';

import { mediaConfined, mediaWide } from '@xingternal/layout-tokens';
import { spaceL, spaceS, spaceXL } from '@xingternal/tokens';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;

  /* We need the page to have at least the same height as the XingView sidebar,
  so the SearchAlertBanner doesn't hide any menu item */
  @media ${mediaConfined} {
    min-height: 900px;
  }
`;

export const BrazeContainer = styled.div`
  &:not(:empty) {
    margin-top: ${spaceL};

    @media ${mediaConfined} {
      margin-top: 0;
      margin-bottom: 68px;
    }
  }
`;

export const NavigationContainer = styled.div`
  margin-bottom: ${spaceS};

  @media ${mediaConfined} {
    margin-bottom: ${spaceL};
  }

  @media ${mediaWide} {
    margin-bottom: ${spaceXL};
  }
`;
